import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { FiLock, FiCheckCircle, FiAlertCircle } from "react-icons/fi";
import { Button, Input } from "../components/ui";
import { resetPassword } from "../api/auth";
import logo from "../Assets/Images/EMPACT LOGO.png";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();

  const [form, setForm] = useState({ password: "", confirmPassword: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (form.password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    if (form.password !== form.confirmPassword) {
      setError("Passwords don't match.");
      return;
    }

    setLoading(true);
    try {
      await resetPassword(token, form.password, form.confirmPassword);
      setSuccess(true);
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setError(err.response?.data?.message || "This reset link is invalid or has expired.");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
        <div className="w-full max-w-sm rounded-lg border border-slate-200 bg-white p-8 text-center shadow-card">
          <FiAlertCircle className="mx-auto h-8 w-8 text-red-500" />
          <p className="mt-3 text-sm text-slate-600">This password reset link is missing its token.</p>
          <Link to="/forgot-password" className="mt-4 inline-block text-sm font-medium text-primary-600 hover:text-primary-700">
            Request a new link
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-sm rounded-lg border border-slate-200 bg-white p-8 shadow-card">
        <div className="mb-6 flex flex-col items-center text-center">
          <img src={logo} alt="Empact Alumni" className="h-9 w-auto" />
          <h1 className="mt-4 text-xl font-bold text-slate-900">Set a new password</h1>
        </div>

        {success ? (
          <div className="flex flex-col items-center gap-3 rounded-lg bg-emerald-50 p-5 text-center">
            <FiCheckCircle className="h-8 w-8 text-emerald-500" />
            <p className="text-sm text-emerald-800">Password reset! Redirecting you to sign in…</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <Input
              label="New password"
              type="password"
              icon={<FiLock className="h-4 w-4" />}
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              placeholder="••••••••"
              required
            />
            <Input
              label="Confirm new password"
              type="password"
              icon={<FiLock className="h-4 w-4" />}
              value={form.confirmPassword}
              onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })}
              placeholder="••••••••"
              required
            />
            {error && (
              <p role="alert" className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600">
                {error}
              </p>
            )}
            <Button type="submit" loading={loading} className="w-full" size="lg">
              Reset password
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
